import DOMPurify from 'dompurify'

// The text the customer sees: line breaks and block ends become spaces so words stay apart,
// other tags are dropped, and entities such as &amp; are decoded
export const getPlainText = (html: string) => {
  const withoutTags = DOMPurify.sanitize(html)
    .replace(/<(br|\/p|\/div|\/li)[^>]*>/gi, ' ')
    .replace(/<[^>]*>/g, '')
  const text = new DOMParser().parseFromString(withoutTags, 'text/html').documentElement.textContent

  return (text ?? '').replace(/\s+/g, ' ').trim()
}
